// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1KdS9","colMin":"styles_colMin__3IPRm","colCheckbox":"styles_colCheckbox__3556o"};